import * as React from "react";
import { merge, $ } from "glamor";
import NoSwatch from "material-ui/svg-icons/image/texture";
import { theme } from "styles/theme";
import classNames from "classnames";
import { getBaseSwatchStyles } from "helpers/swatch-utils";
import { ICollectionSwatch } from "constants/color-swatches";

interface IProps {
    colorSwatches: { [key: string]: ICollectionSwatch };
    [key: string]: any;
}

export const ColorSwatches: React.FunctionComponent<IProps> = ({
    colorSwatches,
    products,
    onSelectColorSwatch,
    onImageEnter,
    onImageLeave,
    productId,
}) => {
    const styles = React.useMemo(() => {
        return merge(
            {
                display: "flex",
                height: "50px",
                overflowX: "auto",
                overflowY: "hidden",
                marginBottom: "15px",
            },
            $(" .colorVariant", {
                display: "inline-block",
                border: "2px solid transparent",
                position: "relative",
                height: "40px",
                width: "40px",
                minWidth: "40px",
                borderRadius: "50%",
                marginRight: "0px",
            }),
            $(" .colorVariant div", {
                display: "block",
                position: "absolute",
                top: "3px",
                left: "3px",
                height: "30px",
                width: "30px",
                borderRadius: "50%",
                border: "solid 1px #e1e1e1",
                backgroundSize: "cover",
            }),
            $(" .selectedColorVariant", {
                border: "2px solid #989898",
            })
        );
    }, []);

    const muiStyles = React.useMemo(() => {
        return {
            noSwatch: {
                height: "30px",
                width: "30px",
                fill: theme.palette.lightGrey,
                position: "absolute" as any,
                top: "3px",
                left: "3px",
            },
        };
    }, []);

    return (
        <div {...styles}>
            {Object.keys(colorSwatches).map((ref) => {
                const product = (products || {})[ref];
                const productImage = product && `${product.__cdn}/product/${product.__images[0]}.jpg`;
                const style = getBaseSwatchStyles(colorSwatches[ref]);
                return (
                    <div
                        data-test={`color-variant-${ref}`}
                        key={ref}
                        className={classNames("colorVariant", { selectedColorVariant: ref === productId })}
                        data-productid={ref}
                        data-image={productImage}
                        onClick={onSelectColorSwatch}
                        onMouseEnter={onImageEnter}
                        onMouseLeave={onImageLeave}
                    >
                        {style ? <div style={style} /> : <NoSwatch style={muiStyles.noSwatch} />}
                    </div>
                );
            })}
        </div>
    );
};
